export default function QwenIcon({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" className={className} fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="24" height="24" rx="6" fill="#7C3AED"/>
      <text x="12" y="16.5" textAnchor="middle" fontSize="10" fontWeight="700" fill="white" fontFamily="sans-serif">QW</text>
    </svg>
  );
}
